import { ScoreType } from '@/modules/schedule/store/models';
import { LastMatchDayResultsWidgetState } from '@/modules/league/models/LastMatchDayResultsWidgetModel';

export interface LeagueState {
  settings?: Settings;
  leagueTable: LeagueTableState;
  nextMatchWidget: NextMatchWidgetState;
  lastMatchWidget: LastMatchWidgetState;
  lastMatchDayResultsWidget: LastMatchDayResultsWidgetState;
  loaded: boolean;
}
export interface Settings {
    activeSeason: Season;
  }
export interface Season {
  id: number;
  teamId: number;
  codeName: string;
  name: string;
  description: string;
  activeRound: Round;
}
export interface Round {
  id: number;
  name: string;
  codeName: string;
}
export interface LeagueTableState {
  isLoaded: boolean;
  leagueTableItems: LeagueTableViewItem[];
}
export interface NextMatchWidgetState {
  isFetched: boolean;
  nextMatch: NextMatchWidgetModel;
}
export interface LastMatchWidgetState {
  isFetched: boolean;
  lastMatch: LastMatchWidgetModel;
}
export interface NextMatchWidgetModel {
  matchId: number;
  matchDateTime: Date;
  matchTypeTitle: string;
  seasonName: string;
  teamHomeId: number;
  teamHomeName: string;
  teamHomeCrestUrl: string;
  teamAwayId: number;
  teamAwayName: string;
  teamAwayCrestUrl: string;
}
export const emptyNextMatchWidgetModel: NextMatchWidgetModel = {
  matchId: 0,
  matchDateTime: new Date(),
  matchTypeTitle: '',
  seasonName: '',
  teamHomeId: 0,
  teamHomeName: '',
  teamHomeCrestUrl: '',
  teamAwayId: 0,
  teamAwayName: '',
  teamAwayCrestUrl: ''};
export interface LastMatchWidgetModel {
    matchId: number;
    matchDateTime: Date;
    matchTypeTitle: string;
    seasonName: string;
    teamHomeId: number;
    teamHomeName: string;
    teamHomeCrestUrl: string;
    teamAwayId: number;
    teamAwayName: string;
    teamAwayCrestUrl: string;
    scoreType: ScoreType;
    homeTeamScore?: number;
    awayTeamScore?: number;
    halfHomeTeamScore?: number;
    halfAwayTeamScore?: number;
  }
export const emptyLastMatchWidgetModel: LastMatchWidgetModel = {
    matchId: 0,
    matchDateTime: new Date(),
    matchTypeTitle: '',
    seasonName: '',
    teamHomeId: 0,
    teamHomeName: '',
    teamHomeCrestUrl: '',
    teamAwayId: 0,
    teamAwayName: '',
    teamAwayCrestUrl: '',
    scoreType: ScoreType.NoScore};
export interface LeagueTableViewItem {
  teamId: number;
  shortName: string;
  crestPictureUrl: string;
  prevOrdinalNumber: number;
  ordinalNumber: number;
  points: number;
  matchNumber: number;
  wins: number;
  draws: number;
  defeats: number;
  scoredGoals: number;
  lostGoals: number;
  balance: number;
  createdOn: Date;
}
